/**
 * Time unit associated with the inflation lag period.
 * tag: 40809
 * @readonly
 * @enum {string} (String)
 */
export enum PaymentStreamInflationLagUnit {
  /** Day */
  Day = 'D',
  /** Week */
  Week = 'Wk',
  /** Month */
  Month = 'Mo',
  /** Year */
  Year = 'Yr',
}
